module.exports = __webpack_public_path__ + "assets/images/4f118a233c751d3a6a2cc77ca1019298.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/icons/about.svg
// module id = 421
// module chunks = 0